import { MetricUId } from "../../Metrics/constants";
import getChartConfigTemplate from "../Templates/StackedBarChart/utils";
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.MEETINGS_WITH_POSITIVE_SURVEY_RESPONSES]: "#0969DA",
  [MetricUId.MEETINGS_WITH_NEUTRAL_OR_NEGATIVE_SURVEY_RESPONSES]: "#F76B15",
  [MetricUId.MEETINGS_WITH_NO_SURVEY_RESPONSES]: "#D0D6DB"
};

const getChartConfig = function (props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.MEETINGS_WITH_POSITIVE_SURVEY_RESPONSES, MetricUId.MEETINGS_WITH_NEUTRAL_OR_NEGATIVE_SURVEY_RESPONSES, MetricUId.MEETINGS_WITH_NO_SURVEY_RESPONSES],
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;